import type { FieldErrors } from "react-hook-form";

const capitalizeMessage = (message: any) => {
    if (typeof message === 'string') {
        return message.charAt(0).toUpperCase() + message.slice(1);
    }
    return '';
}

const processErrorObject = (errorObject: FieldErrors) => {
    const messages: Array<string> = [];
    Object.keys(errorObject).forEach((innerKey) => {
        if (errorObject[innerKey]) {
            const message = errorObject[innerKey]?.message;
            messages.push(capitalizeMessage(message));
        }
    });
    return messages;
}

export const getErrorMessages = (errors: FieldErrors, fields: Array<string>) => {
    const messages: Array<string> = [];
    Object.keys(errors).forEach((key) => {
        if (fields.includes(key)) {
            if (Array.isArray(errors[key])) {
                (errors[key] as any).forEach((errorObject: FieldErrors) => {
                    messages.push(...processErrorObject(errorObject));
                });
            } else if (errors[key]) {
                const message = errors[key]?.message;
                messages.push(capitalizeMessage(message));
            }
        }
    });
    return messages;
}
